import { registerPlugin } from '@capacitor/core';

interface IGoogleLoginPlugin {
  signIn: () => Promise<IUserInfos>;
}

export const GoogleLoginPlugin = registerPlugin<IGoogleLoginPlugin>('GoogleLoginPlugin');
